import React from 'react';

import {Result, ResultDate, ResultSuccess} from '../components';

interface GDriveRequestResultProps {
  key: any;
  result: any;
}

const ErrorMessage = ({result}: any) => {
  const error = result?.value?.response_json?.error || 'Unknown error';

  return <>{error}</>;
};

const ResultSuccessLocal = ({result}: any) => {
  return (
    <>
      <ResultSuccess title="GDrive Upload success" description={result.value.response_json?.response} />
      <ResultDate result={result}/>
    </>
  )
}

const GDriveRequestResult = ({
  result,
}: GDriveRequestResultProps) => {
  return (
    <Result
      result={result}
      successElement={<ResultSuccessLocal result={result}/>}
      failedTitle="GDrive run failed"
      failedDescription={<ErrorMessage result={result}/>}
    />
  );
};

export default GDriveRequestResult;
